module.exports = __webpack_public_path__ + "VAGRoundedStd-Bold.89790f4d5bad08bcdf04.ttf";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Bold.ttf
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Bold.ttf
// module chunks = styles